import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { CtaBand } from '../components/CtaBand';
import { opportunities } from '../data/opportunities';
export function Opportunities() {
  const [sector, setSector] = useState('All sectors');
  const sectors = useMemo(() => ['All sectors', ...Array.from(new Set(opportunities.map(o => o.sector)))], []);
  const visible = sector === 'All sectors' ? opportunities : opportunities.filter(o => o.sector === sector);
  return <>
      <PageHero breadcrumb="Leadership Opportunities" title="Current leadership opportunities." lead="A selection of mandates we can share publicly. Client names remain confidential until later stages of the process." data-id="element-625" data-mp="swztugho7eez" />
      <section className="bg-ivory" data-id="element-626" data-mp="2n84wpikxnmt9">
        <div className="mx-auto max-w-site px-6 py-20 lg:px-10 lg:py-28" data-id="element-627" data-mp="2s9c4hhn2slzx">
          <div className="flex flex-wrap gap-2" role="group" aria-label="Filter by sector" data-id="element-628" data-mp="32eeh0rhr4f5t">
            {sectors.map(s => <button key={s} type="button" onClick={() => setSector(s)} aria-pressed={sector === s} className={`whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors duration-150 ease-out ${sector === s ? 'bg-midnight-900 text-champagne-50' : 'bg-white text-midnight-900/75 ring-1 ring-midnight-900/15 hover:ring-midnight-900/40'}`} data-id="element-629" data-mp="2ybzy67e31fej">
                {s}
              </button>)}
          </div>

          <ul className="mt-12 border-b border-midnight-900/15" data-id="element-630" data-mp="2tblokkwu1xee">
            {visible.map(role => <li key={role.id} className="grid gap-4 border-t border-midnight-900/15 py-8 lg:grid-cols-12 lg:items-center lg:gap-8" data-id="element-631" data-mp="2oh7xgup7ecfj">
                <div className="lg:col-span-4" data-id="element-632" data-mp="3pfl7cl0pv83">
                  <h2 className="font-serif text-3xl text-midnight-900" data-id="element-633" data-mp="3qqolbajx0yo">{role.title}</h2>
                  <p className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-midnight-900/60" data-id="element-634" data-mp="bp2h7lzeeyrr">
                    <span data-id="element-635" data-mp="ft0cflllrpfj">{role.sector}</span>
                    <span aria-hidden="true" data-id="element-636" data-mp="kpqvmhspf156">·</span>
                    <span className="inline-flex items-center gap-1" data-id="element-637" data-mp="knxpd3m06ixp">
                      <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-638" data-mp="polaj8njw5k0" />
                      {role.location}
                    </span>
                  </p>
                </div>
                <p className="text-[15px] leading-relaxed text-midnight-900/75 lg:col-span-5" data-id="element-639" data-mp="3t6vdkpt0d8a6">{role.summary}</p>
                <div className="lg:col-span-3 lg:text-right" data-id="element-640" data-mp="1xy12ixzl7vc">
                  <Link to={`/contact?type=candidate&role=${encodeURIComponent(role.title + ' — ' + role.sector)}`} className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-midnight-900 underline decoration-champagne-500 underline-offset-[6px]" data-id="element-641" data-mp="6qr7db93so9j">
                    Express interest
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-642" data-mp="32tgvkvn5dq3i" />
                  </Link>
                </div>
              </li>)}
          </ul>

          <p className="mt-10 max-w-2xl text-[15px] leading-relaxed text-midnight-900/65" data-id="element-643" data-mp="2sw2gp0gvh9db">
            Don’t see the right role? Most of our mandates are confidential.{' '}
            <Link to="/contact?type=candidate" className="font-medium text-midnight-900 underline decoration-champagne-500 underline-offset-4" data-id="element-644" data-mp="2jy0jyx4692vu">
              Introduce yourself
            </Link>{' '}
            and we’ll be in touch when a suitable opportunity arises.
          </p>
        </div>
      </section>
      <CtaBand data-id="element-645" data-mp="259dsjx19sko9" />
    </>;
}